<template>
	<div class="base-select">
		<label v-if="label">{{ label }}</label>
		<select
			class="browser-default custom-select"
			v-on="listeners"
			v-bind="$attrs"
		>
			<option
				v-for="option in options"
				:key="option"
				:value="option"
				:selected="option === value"
				>{{ option }}</option
			>
		</select>
		<p class="errorMsg" v-if="errorMsg">{{ errorMsg }}</p>
	</div>
</template>

<script>
export default {
	inheritAttrs: false,
	props: {
		options: {
			type: Array,
			required: true
		},
		label: {
			type: String,
			default: ''
		},
		value: {
			type: [String, Number],
			required: true
		},
		errorMsg: {
			type: String
		}
	},
	computed: {
		listeners() {
			return {
				...this.$listeners,
				input: this.valueUpdate
			}
		}
	},
	methods: {
		valueUpdate(e) {
			let selectValue = e.target.value
			this.$emit('input', selectValue)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/components/baseSelect.scss';
</style>
